import { QueryClient } from '@tanstack/react-query';

import { QueryKeys } from '@/app/shared/constants/queryKeys';

export const refreshPortfolioWithdrawalsUi = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: [QueryKeys.USER_PENDING_WITHDRAWALS] }),
    queryClient.invalidateQueries({ queryKey: ['readContracts'] }),
  ]);
